import analytics from './apps/analytics/reducers/analytics';
import basket from './apps/basket/reducers/basket';
import breadcrumbs from './apps/catalogue/reducers/breadcrumbs';
import browserWarnings from './apps/browserWarnings/reducers/browserWarnings';
import catalogue from './apps/catalogue/reducers/catalogue';
import yourSavingsHub from './apps/catalogue/reducers/yourSavingsHub';
import checkout from './apps/checkout/reducers/checkout';
import cookieDisclaimer from './apps/cookieDisclaimer/reducers/cookieDisclaimer';
import userPreferences from './utils/userPreferences/reducers/userPreferences';
import coupons from './apps/coupons/reducers/coupons';
import customerMessages from './apps/customerMessages/reducers/customerMessages';
import dataSync from './apps/dataSync/reducers/dataSync';
import deliveryPageScribeDocument from '[theme-lib]/apps/delivery/reducers/deliveryPageScribeDocument';
import deliveryPass from '[theme-lib]/apps/deliveryPass/reducers/deliveryPass';
import deliveryPassManagement from '[theme-lib]/apps/deliveryPassManagement/reducers/deliveryPassManagement';
import deliverySlot from './apps/deliverySlot/reducers/deliverySlot';
import feedbackPopup from './apps/feedbackPopup/reducers/feedbackPopup';
import footer from './apps/footer/reducers/footer';
import header from './apps/header/reducers/header';
import http from './apps/http/reducers/http';
import loaders from './apps/loaders/reducers/loaders';
import loggedInHomePage from '[theme-lib]/apps/loggedInHomepage/reducers/loggedInHomepage';
import loggedInHomePageStatic from '[theme-lib]/apps/loggedInHomepage/reducers/loggedInHomepageStatic';
import loggedOutHomePageStatic from './apps/loggedOutHomePage/reducers/loggedOutHomePageStatic';
import loginElevated from './apps/login/reducers/loginElevated';
import logosFromScribe from './apps/logosFromScribe/reducers';
import meta from './apps/meta/reducers/meta';
import navigation from './apps/navigation/reducers/navigation';
import nextAvailableDeliverySlot from './apps/deliverySlot/reducers/nextAvailableDeliverySlot';
import notifications from './apps/notifications/reducers/notifications';
import ordersReserved from './apps/ordersReserved/reducers/ordersReserved';
import ordersSummary from './apps/orders/reducers/ordersSummary';
import payments from './apps/payments/reducers/payments';
import products from './apps/products/reducers/products';
import referAFriend from './apps/referAFriend/reducers/referAFriend';
import reviews from './apps/products/reducers/reviews';
import sentry from './apps/sentryTestSuite/reducers/sentry';
import settings from './apps/settings/reducers/settings';
import shoppingLists from './apps/shoppingLists/reducers/shoppingLists';
import sso from './apps/sso/reducers/sso';
import staticContent from './apps/staticContent/reducers/staticContent';
import subscriptions from 'apps/subscriptions/reducers/subscriptions';
import tagRedirects from './apps/tagRedirects/reducers/tagRedirects';
import topNavigation from './apps/topNavigation/reducers/topNavigation';
import trolleyMenu from './apps/trolleyMenu/reducers/trolleyMenu';
import ulp from './apps/ulp/reducers/ulp';
import user from './apps/user/reducers/user';
import properties from './apps/properties/reducers/properties';
import externalisedStrings from './apps/externalisedStrings/reducers';
import foodProfilePopup from './apps/foodProfile/reducers/foodProfilePopup';
import foodProfile from './apps/foodProfile/reducers/foodProfile';

export const domReducers = {
  breadcrumbs,
  browserWarnings,
  cookieDisclaimer,
  coupons,
  deliveryPageScribeDocument,
  feedbackPopup,
  footer,
  header,
  loaders,
  logosFromScribe,
  navigation,
  notifications,
  sso,
  staticContent,
  tagRedirects,
  topNavigation,
  trolleyMenu,
  foodProfilePopup,
};

export const otherReducers = {
  analytics,
  dataSync,
  http,
  meta,
  sentry,
  ulp,
  yourSavingsHub,
};

export const productsReducers = {
  catalogue,
  products,
  reviews,
  subscriptions,
};

export const shoppingReducers = {
  basket,
  checkout,
  deliveryPass,
  deliveryPassManagement,
  deliverySlot,
  nextAvailableDeliverySlot,
  ordersReserved,
  ordersSummary,
  payments,
  shoppingLists,
};

export const userReducers = {
  customerMessages,
  loggedInHomePage,
  loggedInHomePageStatic,
  loggedOutHomePageStatic,
  loginElevated,
  referAFriend,
  settings,
  user,
  userPreferences,
  properties,
  externalisedStrings,
  foodProfile,
};

export default {
  ...domReducers,
  ...otherReducers,
  ...productsReducers,
  ...shoppingReducers,
  ...userReducers,
};
